class CartDeliveryFeeController {
    constructor($sce, settings, shopperService, trolleyService, deliveryPassService, deliveryFeeService) {
        this.$sce = $sce;
        this.settings = settings;
        this.shopperService = shopperService;
        this.trolleyService = trolleyService;
        this.deliveryPassService = deliveryPassService;
        this.deliveryFeeService = deliveryFeeService;

        this.deliveryFeeStructure = null;
    }

    $onInit() {
        this.showDeliveryFeeStructure = false;

        this.deliveryPassService.showShopperDeliveryPassPrompt();
    }

    toggleDeliveryFeeStructure() {
        this.showDeliveryFeeStructure = !this.showDeliveryFeeStructure;

        if (this.showDeliveryFeeStructure) {
            this.deliveryFeeService.getDeliveryFeeStructure().then((response) => {
                this.deliveryFeeStructure = response;
            });
        }
    }
}

CartDeliveryFeeController.$inject = ['$sce', 'Settings', 'ShopperService', 'TrolleyService', 'DeliveryPassService', 'DeliveryFeeService'];

const cartDeliveryFeeComponentDefinition = {
    controller: CartDeliveryFeeController,
    template: require('./cart-delivery-fee.component.html').trim(),
};

module.exports = {
    CartDeliveryFeeController,
    cartDeliveryFeeComponentDefinition,
};



// WEBPACK FOOTER //
// ./src/shop/cart/cart-delivery-fee.component.js